var cov_16orih1mgv = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tag/styles/index.ts",
      hash = "81700ecdb50572cc9610e20ce46afabe5648c483",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tag/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 24
        },
        end: {
          line: 5,
          column: 50
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var tagLess = {};
import genaration from '../../utils/classname';
export var tagClass = (cov_16orih1mgv.s[0]++, genaration(tagLess, 'tag'));